/**
 * Validates APIs Display Name [TCAC-11715]:
 * - Numeric: Names may consist entirely of numbers (e.g., 12345).
 * - Alphabet: Names may consist entirely of alphabets (e.g., abcde).
 * - Alphanumeric: Full use of both letters (A-Z) and numbers (0-9) is permitted.
 * - Special characters: Only hyphens (-), underscores (_), and spaces are allowed; all other symbols are prohibited.
 * - Placement: The name must start with an alphanumeric character (A-Z or 0-9).
 *
 * @param value - The string to validate
 * @param fieldLabel - Optional label for error messages. Defaults to "Display name".
 * @returns Empty string if valid, otherwise the specific error message
 */
export function getApiDisplayNameValidationError(
  value: string,
  fieldLabel: string = "Display name"
): string {
  if (!value) return "";
  if (/^[-_\s]/.test(value)) {
    return `${fieldLabel} must start with an alphanumeric character (A-Z or 0-9).`;
  }
  if (!/^[a-zA-Z0-9_ -]+$/.test(value)) {
    return `${fieldLabel} can only contain letters, numbers, spaces, hyphens, and underscores. Other symbols are not allowed.`;
  }
  return "";
}
